import React from "react";
import { Stack } from "@fluentui/react";
import { IconButton } from "@fluentui/react/lib/Button";
import { UPLOAD_FILE_REMOVE } from "../../redux/constants/metaData";
import { useCheckin } from "../../redux/hooks/useCheckin";
import { useTools } from "../../redux/hooks/useTools";
import { useUploadFileRecords } from "../../theme/styles/UploadFileRecordsStyle";
import { useTheme } from "../../theme/OAS365Theme";
import {
  Box,
  Typography,
  Chip,
  IconButton as MuiIconButton,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";

const ViewCopyRecord = () => {
  const {
    uploadViewCopyCount,
    viewCopyFiles,
    viewRequired,
    uploadFiles,
  } = useCheckin();
  const { onViewCopyUploadChange } = useTools();
  const styleTheme = useUploadFileRecords();
  const theme = useTheme();

  const cancelIcon = { iconName: "Cancel" };

  function removeUploadedFile(
    fileIndex,
    viewCopyFiles,
    viewRequired,
    uploadFiles
  ) {
    const files = viewCopyFiles ? [...viewCopyFiles] : [];
    if (files.length && fileIndex >= 0) {
      files.splice(fileIndex, 1);
      onViewCopyUploadChange(files, files.length, files.length, viewRequired, uploadFiles, false);
    }
  }

  function formatFileName(name) {
    if (name.length > 25) {
      const ext = name.split(".").pop();
      const nameWithoutExt = name.substring(0, name.lastIndexOf("."));
      const truncatedName = nameWithoutExt.substring(0, 20) + "...";
      return `${truncatedName}.${ext}`;
    }
    return name;
  }

  if (uploadViewCopyCount === 0) {
    return <></>;
  }

  return (
    <Box>
      <Stack tokens={{ childrenGap: 8 }} style={{ width: "100%" }}>
        {viewCopyFiles.map((item, index) => (
          <Box
            key={`file-${index}`}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: "#f8f9fa",
              border: "1px solid #e9ecef",
              borderRadius: "4px",
              padding: "8px 12px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                flex: 1,
                minWidth: 0,
              }}
            >
              <InsertDriveFileIcon
                sx={{ color: "#4c8d6a", fontSize: 20, flexShrink: 0 }}
              />

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  minWidth: 0,
                  flex: 1,
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    fontFamily: theme.fonts.regular,
                    fontWeight: 500,
                    color: "#212529",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    flex: 1,
                    minWidth: 0,
                  }}
                  title={item.name}
                >
                  {formatFileName(item.name)}
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    mt: 0.5,
                  }}
                >
                  <Chip
                    label={item.size}
                    size="small"
                    sx={{
                      height: 20,
                      fontSize: "10px",
                      backgroundColor: "#e8f5e9",
                      color: "#2e7d32",
                      fontFamily: theme.fonts.regular,
                    }}
                  />
                </Box>
              </Box>
            </Box>

            <MuiIconButton
              size="small"
              onClick={(ev) => {
                removeUploadedFile(
                  index,
                  viewCopyFiles,
                  viewRequired,
                  uploadFiles
                );
              }}
              sx={{
                color: "#dc3545",
                "&:hover": {
                  backgroundColor: "rgba(220, 53, 69, 0.1)",
                },
                flexShrink: 0,
                marginLeft: 1,
              }}
            >
              <CancelIcon fontSize="small" />
            </MuiIconButton>
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

export default ViewCopyRecord;
